import { Dispatch } from "react";
import { State, Action } from "./definitions";
export const initialize = (price: number) => (state: State) => ({
  ...state,
  price
});
export const initialState = {
  price: 0,
  rate: "",
  pricePerUnit: "",
  costPerUnit: ".15",
  errors: {}
};

// Actions
const actionRoot = "productDetails/expandedDescription/calculator/cottonCandy";
const makeAction = (action: string) => `${actionRoot}/${action}`;
const rateChanged = makeAction("rateChanged");
const pricePerUnitChanged = makeAction("pricePerUnitChanged");
const costPerUnitChanged = makeAction("costPerUnitChanged");
const calculationsChanged = makeAction("calculateClicked");
const dataReinitialized = makeAction("dataReinitialized");

// internal actions
export const errorRaised = makeAction("errorRaised");
export const actions = {
  rateChanged,
  pricePerUnitChanged,
  costPerUnitChanged,
  calculationsChanged,
  dataReinitialized
};
export const reducer = (state: State, {
  type,
  payload
}: Action) => {
  switch (type) {
    case rateChanged:
      return {
        ...state,
        rate: payload
      };
    case pricePerUnitChanged:
      return {
        ...state,
        pricePerUnit: payload
      };
    case costPerUnitChanged:
      return {
        ...state,
        costPerUnit: payload
      };
    case calculationsChanged:
      return {
        ...state,
        ...payload
      };
    case dataReinitialized:
      return initialize(payload)(initialState);
    case errorRaised:
      return {
        ...state,
        errors: payload
      };
    default:
      throw new Error(`Action ${type} is not a valid action`);
  }
};

// Thunks
const calculate = (state: State) => (dispatch: Dispatch<Action>) => {
  const {
    price,
    rate,
    pricePerUnit,
    costPerUnit
  } = state;

  // validations
  const requiredFieldText = "Input is required";
  const errors: {
    [index: string]: string;
  } = {};
  if (!rate) {
    errors.rate = requiredFieldText;
  }
  if (!pricePerUnit) {
    errors.pricePerUnit = requiredFieldText;
  }
  if (!costPerUnit) {
    errors.costPerUnit = requiredFieldText;
  }
  if (Object.keys(errors).length) {
    dispatch({
      type: errorRaised,
      payload: {
        ...errors
      }
    });
    return;
  }

  // calculations
  const profitPerUnit = parseFloat(pricePerUnit) - parseFloat(costPerUnit);
  const breakEven = price / profitPerUnit / parseFloat(rate);
  const dailyProfit = parseFloat(rate) * profitPerUnit * 8;
  dispatch({
    type: calculationsChanged,
    payload: {
      profitPerUnit,
      breakEven,
      dailyProfit,
      errors: {
        ...errors
      }
    }
  });
};
export const thunks = {
  calculate
};